import AdminVaspDetailsSubHeader from './AdminVaspDetailsSubHeader'

export default AdminVaspDetailsSubHeader
